<section class="d-flex gap-3 flex-column">
  <article title="headings" class="d-flex gap-3 flex-column">
    <h1>h1 - Heading</h1>
    <h2>h2 - Heading</h2>
    <h3>h3 - Heading</h3>
    <h4>h4 - Heading</h4>
    <h5>h5 - Heading</h5>
    <h6>h6 - Heading</h6>
  </article>
  <article title="primitiv-interactables" class="d-flex gap-3 flex-column w-25">
    <button class="btn btn-primary">Primary Button</button>
    <button class="btn btn-secondary">Secondary Button</button>
    <button class="btn btn-tertiary">Tertiary Button</button>
    <div>
      <input type="checkbox" id="checkbox">
      <label for="checkbox">Checkbox</label>
    </div>
    <div>
      <input class="form-control text" type="text">
    </div>
    <div class="row">
            <span class="col-auto d-flex">
              <input class="form-control date-input"
                     placeholder="dd.mm.yyyy"
                     name="dpstart" id="dpstart"
                     ngbDatepicker
                     #dStart="ngbDatepicker">
              <button class="col datepicker-button d-inline-block btn btn-secondary" type="button"
                      (click)="dStart.toggle()">
                <ucs-icon [shape]="'calendar'" [class]="'blue'"></ucs-icon>
              </button>
            </span>
    </div>
    <div>
      <ng-select [items]="['Option 1', 'Option 2', 'Option 3']"
                 placeholder="Select an option"
                 class="w-100">
      </ng-select>
    </div>
    <div>
      <a href="/demo">a link</a>
    </div>
  </article>
  <article title="complex-interactables" class="d-flex gap-3 flex-column w-25">
    <div>
      <ucs-search-toggle-button [labelLeft]="'leftOption'" [labelRight]="'rightOption'"></ucs-search-toggle-button>
    </div>
    <div>
      <ucs-info-icon [infoText]="'This is some information about the feature.'" [placement]="NgxFloatUiPlacements.RIGHT"></ucs-info-icon>
    </div>
    <div>
      <i [floatUi]="'test'"
         [disableAnimation]="true"
         [positionFixed]="true"
         [placement]="NgxFloatUiPlacements.RIGHT"
         [showTrigger]="NgxFloatUiTriggers.hover">
        info popper
      </i>
    </div>
    <div>
      <ucs-toggle-switch [isEnabled]="true"></ucs-toggle-switch>
    </div>
    <ucs-price-input [id]="'demo_price'" [name]="'demoPrice'" [class]="'form-control'"
    ></ucs-price-input>
    <ucs-dropdown-menu [label]="'Dropdown Button'">
      <button class="dropdown-item">Action</button>
      <a class="dropdown-item">Another action</a>
      <a class="dropdown-item">Something else here</a>
    </ucs-dropdown-menu>
  </article>
  <article title="text-styles" class="d-flex gap-3 flex-column w-50">
    <ucs-datepicker-range></ucs-datepicker-range>
  </article>
    <article title="icons" class="d-flex gap-3 flex-column">
    <div class="d-flex gap-3 flex-wrap">
      <ucs-icon [shape]="'info'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'check'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'delete'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'edit-3'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'calendar'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'filter'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'bookmark'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'mail'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'alert-triangle'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'plus-circle'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'minus'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'eye'" [class]="'blue'"></ucs-icon>
      <ucs-icon [shape]="'eye-off'" [class]="'blue'"></ucs-icon>
    </div>
  </article>
  <article title="accordion" class="d-flex gap-3 flex-column">
    <ucs-accordion [title]="'Accordion (open by default)'">
      <p>This is the content inside the accordion.</p>
    </ucs-accordion>
    <ucs-accordion [title]="'Accordion with eye toggle'" [showEyeOption]="true"
                   [eyeActiveText]="'Hide content'" [eyeHiddenText]="'Show content'">
      <p>This accordion has an eye toggle option.</p>
    </ucs-accordion>
  </article>
  <article title="dropzone" class="d-flex gap-3 flex-column">
    <ucs-dropzone></ucs-dropzone>
    <ucs-dropzone [disabled]="true" [disabledText]="'Upload disabled'"></ucs-dropzone>
  </article>
  <article title="dialog" class="d-flex gap-3 flex-column w-25">
    <button class="btn btn-primary" (click)="noticeBuyNowForPBDialog.open()">Basic dialog</button>
    <ucs-basic-dialog [dialogId]="'noticeBuyNow'" #noticeBuyNowForPBDialog
                      [title]="'offer-maintenance.buynow-notice-modal-head' | translate"
                      [rejectText]="'ucs.cancel' | translate"
                      [confirmText]="'ucs.save' | translate"
                      [verticallyCentered]="false"
                      (confirm)="noticeBuyNowForPBDialog.close()">
      {{ 'offer-maintenance.buynow-notice' | translate }}
    </ucs-basic-dialog>
  </article>
</section>
